/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Index_DirectInputs */

const en_faq_index_direct = /** @type {(inputs: Faq_Index_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how we work`)
};

const lv_faq_index_direct = /** @type {(inputs: Faq_Index_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt, kā mēs strādājam`)
};

/**
* | output |
* | --- |
* | "See how we work" |
*
* @param {Faq_Index_DirectInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_index_direct = /** @type {((inputs?: Faq_Index_DirectInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Index_DirectInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_index_direct(inputs)
	return en_faq_index_direct(inputs)
});